"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const art_layout_names_1 = __importDefault(require("./art-layout-names"));
const art_sets_backgrounds_1 = __importDefault(require("./art-sets-backgrounds"));
const tiles_1 = require("../tiles");
const eightLayouts = [
    {
        id: art_layout_names_1.default.EIGHT_SQUARE,
        displayName: 'Octet',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'square_8x8_8_1',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_8_2',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5919439579684763,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_8_3',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.3161120840630473,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_8_4',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.4080560420315236,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_8_5',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.37828371278458844,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_8_6',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5919439579684763,
                            y: 0.37828371278458844,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_8_7',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.3161120840630473,
                            y: 0.37828371278458844,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    },
                    {
                        id: 'square_8x8_8_8',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.4080560420315236,
                            y: 0.37828371278458844,
                            width: 0.07443082311733801,
                            height: 0.07443082311733801
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'square_12x12_8_1',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.22679509632224168,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_8_2',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.35464098073555167,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_8_3',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.6366024518388792,
                            y: 0.22679509632224168,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_8_4',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.6366024518388792,
                            y: 0.35464098073555167,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_8_5',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.2530647985989492,
                            y: 0.22679509632224168,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_8_6',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.2530647985989492,
                            y: 0.35464098073555167,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_8_7',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.22679509632224168,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    },
                    {
                        id: 'square_12x12_8_8',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.35464098073555167,
                            width: 0.11033274956217162,
                            height: 0.11033274956217162
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_8_1',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.3178633975481611,
                            y: 0.31961471103327493,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_8_2',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.12697022767075306,
                            y: 0.31961471103327493,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_8_3',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.31961471103327493,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_8_4',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.6996497373029772,
                            y: 0.31961471103327493,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_8_5',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.3178633975481611,
                            y: 0.1287215411558669,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_8_6',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.12697022767075306,
                            y: 0.1287215411558669,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_8_7',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.1287215411558669,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    },
                    {
                        id: 'couch_8_8',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.6996497373029772,
                            y: 0.1287215411558669,
                            width: 0.1733800350262697,
                            height: 0.1733800350262697
                        }
                    }
                ]
            }
        ]
    }
];
exports.default = eightLayouts;
//# sourceMappingURL=eight.js.map